import React, { useEffect, useState } from "react";
import { getLinkRegistrations } from "../services/sessionLinkService";
import "./sessionLinks.css";

const LinkRegistrationsDrawer = ({ link, onClose }) => {
  const [registrations, setRegistrations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const result = await getLinkRegistrations(link.id);
      if (result.status === 200) setRegistrations(result.data);
      setLoading(false);
    };
    load();
  }, [link.id]);

  const formatDate = (iso) =>
    iso ? new Date(iso).toLocaleString("en-IN", { timeZone: "Asia/Kolkata" }) : "—";

  return (
    <>
      <div className="sl-drawer-overlay" onClick={onClose} />
      <div className="sl-drawer">
        <div className="sl-drawer-header">
          <div>
            <h3>Registrations — {link.slug || link.token?.slice(0, 12) + "..."}</h3>
            <span style={{ fontSize: 13, color: "#6b7280" }}>
              {registrations.length} lead{registrations.length !== 1 ? "s" : ""}
            </span>
          </div>
          <button className="sl-drawer-close" onClick={onClose}>✕</button>
        </div>

        <div className="sl-drawer-body">
          {loading ? (
            <p style={{ color: "#6b7280" }}>Loading registrations...</p>
          ) : registrations.length === 0 ? (
            <div className="sl-empty">
              <span className="sl-empty-icon">📭</span>
              No registrations yet for this link.
            </div>
          ) : (
            <table className="sl-reg-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Type</th>
                  <th>Registered At</th>
                </tr>
              </thead>
              <tbody>
                {registrations.map((r, i) => (
                  <tr key={r.id}>
                    <td>{i + 1}</td>
                    <td>{r.name}</td>
                    <td>{r.email}</td>
                    <td>{r.countryCode} {r.mobile}</td>
                    <td>
                      <span className={`sl-reg-type ${r.registrationType}`}>
                        {r.registrationType?.replace(/_/g, " ")}
                      </span>
                    </td>
                    <td>{formatDate(r.registeredAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </>
  );
};

export default LinkRegistrationsDrawer;
